import { MDBContainer } from 'mdb-react-ui-kit'
import React from 'react'
import {
    MDBFooter,
    MDBIcon,
    MDBInput,
    MDBCol,
    MDBRow,
    MDBBtn
} from 'mdb-react-ui-kit';
import { EasyMembrLogo } from '../assets/images/images';
import { useNavigate } from 'react-router';


const LandingFooter = ({ from }) => {

    const navigate = useNavigate();

    const handleDemoClick = () => {
        navigate('/bookademo');
    };
    // const handleProductsClick = (data) => {
    //     navigate(data);
    // };

    return (
        <>

            <div className='lp'>
                <div className="footer">
                    <MDBFooter className='text-center'>
                        <MDBContainer className='py-5'>
                            <section className=''>
                                <MDBRow>
                                    <MDBCol lg='3' md='6' className='mb-4 mb-md-0 position-relative  text-left'>


                                        <img src={EasyMembrLogo} className='position-absolute' alt="" width={150} style={{ filter: 'brightness(10)', top: '-17px' }} />
                                        <br /> <br />
                                        <ul className='list-unstyled mb-0'>

                                            <li>
                                                <a href="#" className="text-white">
                                                    Sundaraiah Vignana Kendram, Survey No 91, Gachibowli Rd, Madhava Reddy Colony, Gachibowli, Hyderabad, Telangana 500032
                                                </a>
                                            </li>
                                        </ul>

                                    </MDBCol>

                                    <MDBCol lg='3' md='6' className='mb-4 mb-md-0 text-left'>
                                        <h5 className='text-capitalize fw-400'>Products</h5>




                                        <ul className='list-unstyled mb-0'>
                                            <li>
                                                <a href='/easymembr' className='text-white'>
                                                    Gym Management Software
                                                </a>
                                            </li>
                                            <li>
                                                <a href='/yogastudio' className='text-white'>
                                                    Yoga Studio Software
                                                </a>
                                            </li>
                                            <li>
                                                <a href='/dancestudio' className='text-white'>
                                                    Dance Studio Software
                                                </a>
                                            </li>
                                            {/* <li>
                                                <a href='/martialstudio' className='text-white'>
                                                    Martial Arts Studio Software
                                                </a>
                                            </li>
                                            <li>
                                                <a href='/pilatesstudio' className='text-white'>
                                                    Pilates Studio Software
                                                </a>
                                            </li>
                                            <li>
                                                <a href="/swimmingstudio" className="text-white">
                                                    Swimming Pool Management Software
                                                </a>
                                            </li> */}
                                        </ul>

                                    </MDBCol>

                                    <MDBCol lg='3' md='6' className='mb-4 mb-md-0 text-left'>
                                        <h5 className='text-capitalize fw-400'>Resources</h5>

                                        <ul className='list-unstyled mb-0'>
                                            <li>
                                                <a href='/products' className='text-white' >
                                                    Products
                                                </a>
                                            </li>
                                            <li>
                                                <a href='/easymembr' className='text-white'>
                                                    Member Management Software
                                                </a>
                                            </li>
                                            <li>
                                                <a href='/easybook' className='text-white'>
                                                    Class Management Software
                                                </a>
                                            </li>
                                            {/* <li>
                                                <a href='/easylead' className='text-white'>
                                                    Lead Management Software
                                                </a>
                                            </li> */}
                                            <li>
                                                <a href='/commercials' className='text-white'>
                                                    Pricing
                                                </a>
                                            </li>
                                            <li>
                                                <a href='/contactus' className='text-white'>
                                                    Contact
                                                </a>
                                            </li>
                                        </ul>
                                    </MDBCol>

                                    <MDBCol lg='3' md='6' className='mb-4 mb-md-0 text-left'>
                                        <h5 className='text-capitalize fw-400'>Company</h5>

                                        <ul className='list-unstyled mb-0'>
                                            <li>
                                                <a href='/termsandconditions' className='text-white'>
                                                    Terms and Conditions
                                                </a>
                                            </li>
                                            <li>
                                                <a href='/privacypolicy' className='text-white'>
                                                    Privacy Policy
                                                </a>
                                            </li>
                                            {/* <li>
                                                <a href='#!' className='text-white'>
                                                    Return, refund, & cancellation policy
                                                </a>
                                            </li> */}
                                            <li>
                                                <a href="#!" className="text-white">
                                                    Follow us
                                                </a>
                                                <section className='mb-4'>
                                                    <a href="https://www.facebook.com/zen.cruz.m?mibextid=LQQJ4d" target="_blank" rel="noopener noreferrer">
                                                        <MDBIcon fab icon='facebook-f' color='light' className='pe-2' />
                                                    </a>
                                                    <a href="https://www.google.com/search?q=easymembr&oq=easymembr&gs_lcrp=EgZjaHJvbWUqBggAEEUYOzIGCAAQRRg7MgcIARAAGIAEMgcIAhAAGIAEMggIAxAAGAUYHjIKCAQQABgFGAoYHjIICAUQABgFGB4yCggGEAAYgAQYogQyBwgHEAAY7wXSAQk4ODQwajBqMTWoAgiwAgE&sourceid=chrome&ie=UTF-8" target="_blank" rel="noopener noreferrer">
                                                        <MDBIcon fab icon='google' color='light' className='px-2' />
                                                    </a>
                                                    {/* <a href="https://www.youtube.com/YourChannel" target="_blank" rel="noopener noreferrer">
                                                        <MDBIcon fab icon='youtube' color='light' className='px-2' />
                                                    </a> */}
                                                    {/* <a href="https://www.instagram.com/YourHandle" target="_blank" rel="noopener noreferrer">
                                                        <MDBIcon fab icon='instagram' color='light' className='px-2' />
                                                    </a> */}
                                                    <a href="https://www.linkedin.com/company/zencruzms/?viewAsMember=true" target="_blank" rel="noopener noreferrer">
                                                        <MDBIcon fab icon='linkedin-in' color='light' className='px-2' />
                                                    </a>
                                                </section>

                                            </li>
                                        </ul>
                                    </MDBCol>
                                </MDBRow>
                            </section>
                        </MDBContainer>

                        <div className='text-center p-3' style={{ backgroundColor: 'rgba(0, 0, 0, 0.2)' }}>
                            ©{new Date().getFullYear()} Copyright
                            <a className='text-white ps-1' href='#'>
                                EasyMembr.
                            </a>
                        </div>
                    </MDBFooter>
                </div>
            </div>
            {from !== "demo" && <div className="">
                <button className='me-3 demo-btn' color='primary' onClick={handleDemoClick}>
                    Book A
                    <span> Demo</span>
                </button>
            </div>}
        </>
    )
}

export default LandingFooter
